import { useCallback, useState } from "react";

import DashboardFooter from "../DashboardMain/DashboardFooter"
import PeriodPicker from "./PeriodPicker"
import {AVAILABLE_PERIODS} from "./settings";

export function EnergyFooter(props) {
  const {selectedFrequency, reportToDate, reportFromDate, site, checkedVariables, 
        selectedPeriod, setReportFromDate, setReportToDate, setSelectedFrequency, setSelectedPeriod,
        onClickParagon,paragonSiteID, activeParagon, handleParagonEnergySites} = props
    
  const selectedPeriodLabel = AVAILABLE_PERIODS.find(({id}) => id === selectedPeriod).label;
  const [showPeriodPicker, setShowPeriodPicker] = useState(false);

  const onConfirmPeriod = useCallback((newReportFromDate,newReportToDate,newSelectedPeriod,newSelectedFrequency) => {
    setShowPeriodPicker(false);
    setReportFromDate(newReportFromDate);
    setReportToDate(newReportToDate);
    setSelectedPeriod(newSelectedPeriod);
    setSelectedFrequency(newSelectedFrequency);
    // eslint-disable-next-line
  },[],);

  ////CONFIGURAZIONE FOOTER
  const configFooter = [
    {
      Component: DashboardFooter,
      config: {
        onShowPeriodPicker:useCallback(() => setShowPeriodPicker(true),[],),
        selectedPeriodLabel,
        selectedFrequency,
        site,
        paragonSiteID,
        categoryID:1,
        reportFromDate,
        reportToDate,
        checkedVariables,
        type:"ENERGY",
        onClickParagon,
        activeParagon,
        handleParagonEnergySites,
      }
    },
    {
      Component: PeriodPicker,
      config: {
        showPeriodPicker,
        selectedPeriod,
        selectedFrequency,      
        reportToDate,
        reportFromDate,
        onClose: useCallback(() => setShowPeriodPicker(false),[]),
        onConfirm:onConfirmPeriod,
      }
    }
  ]
  
  return (
    configFooter && configFooter.map((content, index) => (
      <content.Component key={index} {...content.config}/>
    ))
  )
}
